'use client';

import { theme } from '@prose-ui';
import { legacyTheme, styled } from '@prose-ui/legacy';

import { Image } from 'Components/Image';
import { breakpoints } from 'Components/ThemeProvider';
import { Typography } from 'Components/Typography';

import * as pressExcerpts from 'assets/content/reviews/pressExcerpts';

import useMedia from 'utils/useMedia';

import { GridReviews } from './GridReviews';

const PressGridItem = styled.section`
  display: flex;
  flex-flow: column;
  align-items: center;
  min-width: 50%;
  max-width: 380px;

  margin-bottom: 0;
  margin-top: 40px;

  ${legacyTheme.breakpoints.up('sm')} {
    margin-top: 80px;
    margin-bottom: 0;
  }
`;

const StyledTypography = styled(Typography)`
  font-size: 24px;
  width: 325px;
  margin-bottom: ${theme.spacing['3x']};
`;

const StyledImage = styled(Image)`
  max-height: 60px;
  width: auto;
`;
const Separator = styled.div`
  width: 100%;
  height: 1px;
  background-color: ${theme.colors.tertiary[200]};
  margin-top: ${theme.spacing['10x']};
`;

export const PressReviews = () => {
  const isMobile = useMedia(`(max-width: ${breakpoints.sm - 1}px)`);

  return (
    <GridReviews
      background={theme.colors.neutral[200]}
      dataTestId="reviews-press-block"
      title="In the press"
      titleMarkupName="h2"
    >
      {!isMobile && <Separator />}
      {Object.values(pressExcerpts).map(({ content: textContent, imgAlt, imgSrc, link }) => (
        <PressGridItem key={imgAlt}>
          <>
            {link ? (
              <a href={link} rel="noopener noreferrer" target="_blank">
                <StyledTypography align="center" color="noir" variant="h3" whiteSpace="pre-line">
                  {textContent}
                </StyledTypography>
              </a>
            ) : (
              <StyledTypography
                align="center"
                color="noir"
                markupName="h2"
                variant="h3"
                whiteSpace="pre-line"
              >
                {textContent}
              </StyledTypography>
            )}
            <StyledImage alt={imgAlt} src={imgSrc} />
          </>
        </PressGridItem>
      ))}
    </GridReviews>
  );
};
